import React from 'react';
import nodo from './../../images/router.png';
import blue from './../../images/blue.png';
import nap from './../../images/nap.png';
import red from './../../images/red.png';
import emi from './../../images/5g.png';
import map from './../../images/map.png';
const Marker = (options) => {
    const [marker, setMarker] = React.useState();
    const contentRef = React.useRef(null);
    let icon = map;
    const legend = options.legend;
    const { ico = image } = options;
    let size = 35;
    if (ico === 'nodo') icon = nodo;
    if (ico === 'blue') icon = blue;
    if (ico === 'nap') {
        icon = nap;
        size = 30;
    }

    if (ico === 'red') icon = red;

    if (ico === 'emi') {
        size = 35;
        icon = emi;
    }

    var image = {
        // url: "data:image/png;base64,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",
        url: icon,
        scaledSize: new window.google.maps.Size(size, size),
    };
    React.useEffect(() => {
        if (!marker) {
            setMarker(
                new window.google.maps.Marker({
                    icon: image,
                    animation: window.google.maps.Animation.DROP,
                })
            );
        }

        return () => {
            if (marker) {
                marker.setMap(null);
            }
        };
    }, [marker]);

    React.useEffect(() => {
        if (marker) {
            const infowindow = new window.google.maps.InfoWindow({
                content: legend,
            });
            marker.setOptions(options);

            marker.addListener('click', () => {
                infowindow.open({
                    anchor: marker,
                    shouldFocus: false,
                });
            });
        }
    }, [marker, options]);

    return null;
};
export default Marker;
